var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.presenter.textClass},[_vm._v(_vm._s(_vm.presenter.service))])}
var staticRenderFns = []

export { render, staticRenderFns }